"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var logger_const_1 = require("../const/logger.const");
var logger_class_1 = require("../logger/logger.class");
function formatThousands(value, delimiter) {
    if (delimiter === void 0) { delimiter = ' '; }
    if (lodash_1.isString(value) && lodash_1.isEmpty(value)) {
        logger_class_1.logger.message('No/incorrect value provided', logger_const_1.LOG_TYPE.error);
        return '';
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}
exports.formatThousands = formatThousands;
function formatTwoDigits(value) {
    var isInvalidNumber = value < 0 || lodash_1.isArray(value) || lodash_1.isObject(value) || lodash_1.isNaN(value);
    if (isInvalidNumber) {
        logger_class_1.logger.message('No/incorrect value provided', logger_const_1.LOG_TYPE.error);
        return '';
    }
    var stringValue = value.toString();
    if (stringValue.length > 2) {
        logger_class_1.logger.message('More than 2 digits, return the same value', logger_const_1.LOG_TYPE.info);
        return value;
    }
    var isSingleDigit = stringValue.length === 1;
    return isSingleDigit ? "0" + value : stringValue;
}
exports.formatTwoDigits = formatTwoDigits;
